import { makeObservable, observable } from 'mobx';
import { API } from '~/api';
import { ApiService } from '~/service/service.api';
import { DashboardService } from '~/service/service.dashboard';
import { Model } from '~/shared/service/service.base';
import { Async } from '~/shared/tools/async';

@Model()
export class DashboardUsersShelvesModel {
	readonly async = new Async();

	@observable.ref items: API.AnalyticsTopUsersItem[] = [];

	constructor(
		private api: ApiService,
		private dashboardSvc: DashboardService,
	) {
		makeObservable(this);
	}

	fetchData = () => {
		this.async.call(async () => {
			const { data } = await this.api.analyticsTopUsers();
			return () => {
				this.items = data.items;
			};
		});
	};
}
